export enum ChartTypeCode{
    Line = 0,
    Column = 1
}